import styled, { css } from 'styled-components';
import {
  gridColumnGap,
  GridProps,
  margin,
  MarginProps,
  padding,
  PaddingProps,
  textAlign,
  TextAlignProps,
} from 'styled-system';

export const PrepaidWrapper = styled.div<PaddingProps>`
  ${({ theme }) => css`
    background: ${theme.colors.primary.extraLight};
    border-radius: ${theme.radii[4]}px;
  `};
  ${padding};
`;

export const Name = styled.div<GridProps>`
  display: flex;
  align-items: center;
  ${gridColumnGap};
`;

export const Prepaid = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Usage = styled.div<MarginProps>`
  ${margin};
  display: flex;
  justify-content: flex-end;
`;

export const Used = styled.div<TextAlignProps & PaddingProps>`
  display: flex;
  flex-direction: column;
  ${textAlign};
  ${padding};
`;

export const Overage = styled.div<TextAlignProps & PaddingProps>`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.gray.extraLight};
  `};
  display: flex;
  flex-direction: column;
  ${textAlign};
  ${padding};
`;

export const RowWrapper = styled.div<MarginProps>`
  ${margin};
`;
